import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface Question {
  id: number;
  text: string;
  options: { label: string; value: number }[];
}

const questions: Question[] = [
  {
    id: 1,
    text: '在吵雜的餐廳或聚會中，您是否經常聽不清楚別人說的話？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 2,
    text: '您是否經常需要請別人重複說過的話？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 3,
    text: '看電視或聽音樂時，您是否經常把音量調得比別人高？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 4,
    text: '在電話中交談時，您是否覺得聽起來比較吃力？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 5,
    text: '女性或小孩的聲音（較高頻率），您是否聽得比較吃力？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 6,
    text: '您是否經常聽不到門鈴、鳥叫聲或微波爐的提示聲？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 7,
    text: '您是否覺得很多人說話含糊不清，好像「嘴巴沒張開」？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 8,
    text: '您是否因為聽力問題而減少參加社交活動？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 9,
    text: '您是否覺得自己的聽力比同齡人差？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 10,
    text: '家人或朋友是否曾建議您去檢查聽力？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 11,
    text: '您是否經常聽到耳鳴（嗡嗡聲、鈴聲）？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
  {
    id: 12,
    text: '您是否覺得某一邊耳朵的聽力比另一邊差？',
    options: [
      { label: '總是如此', value: 4 },
      { label: '經常如此', value: 3 },
      { label: '有時如此', value: 2 },
      { label: '很少如此', value: 1 },
      { label: '從不如此', value: 0 },
    ],
  },
];

function getResultLevel(score: number) {
  if (score <= 12) {
    return {
      level: '聽力正常',
      color: 'text-[#1B3D2A]',
      bg: 'bg-[#1B3D2A]/8',
      border: 'border-[#1B3D2A]/20',
      desc: '您的聽力狀況良好，建議保持每年一次的聽力檢查習慣，維持健康的生活方式。',
      action: '定期檢查',
      urgency: 'low',
    };
  }
  if (score <= 24) {
    return {
      level: '輕度聽力風險',
      color: 'text-[#D4A574]',
      bg: 'bg-[#D4A574]/8',
      border: 'border-[#D4A574]/20',
      desc: '您可能存在輕度的聽力困難，建議安排一次專業聽力檢查，及早了解聽力狀況。',
      action: '安排檢查',
      urgency: 'medium',
    };
  }
  if (score <= 36) {
    return {
      level: '中度聽力風險',
      color: 'text-[#C75D3A]',
      bg: 'bg-[#C75D3A]/8',
      border: 'border-[#C75D3A]/20',
      desc: '您可能有中度的聽力損失，建議盡快預約專業聽力檢查，評估是否需要助聽器輔助。',
      action: '盡快預約',
      urgency: 'high',
    };
  }
  return {
    level: '重度聽力風險',
    color: 'text-[#A33D2A]',
    bg: 'bg-[#A33D2A]/8',
    border: 'border-[#A33D2A]/20',
    desc: '您可能存在顯著的聽力困難，建議盡快尋求專業聽力師的協助，以改善日常溝通品質。',
    action: '立即預約',
    urgency: 'critical',
  };
}

function ProgressBar({ current, total }: { current: number; total: number }) {
  const pct = ((current + 1) / total) * 100;
  return (
    <div className="w-full h-2 bg-[#E8E0D6] rounded-full overflow-hidden">
      <div
        className="h-full bg-[#1B3D2A] rounded-full transition-all duration-500 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}

export default function HearingTestPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'intro' | 'quiz' | 'result'>('intro');
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState<number[]>([]);

  const startQuiz = () => {
    setStep('quiz');
    setCurrentQ(0);
    setAnswers([]);
  };

  const selectOption = (value: number) => {
    const nextAnswers = [...answers, value];
    setAnswers(nextAnswers);
    if (currentQ + 1 >= questions.length) {
      setStep('result');
    } else {
      setCurrentQ(currentQ + 1);
    }
  };

  const totalScore = answers.reduce((a, b) => a + b, 0);
  const result = step === 'result' ? getResultLevel(totalScore) : null;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Hero */}
      <section className="relative overflow-hidden bg-[#F8F5F1] pt-28 pb-14 md:pt-36 md:pb-20">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-[#D4A574]/10 blur-3xl" />
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-[#1B3D2A]/8 blur-3xl" />
        <div className="relative max-w-3xl mx-auto px-5 md:px-8 text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-[#1B3D2A]/8">
            <i className="ri-headphone-line text-2xl text-[#1B3D2A]"></i>
          </div>
          <h1 className="text-2xl md:text-4xl font-bold text-[#1B3D2A] leading-snug">
            線上聽力自我檢測
          </h1>
          <p className="mt-3 md:mt-4 text-[#5A6B5A] text-base md:text-lg leading-relaxed max-w-xl mx-auto">
            透過 12 道簡單問題，快速評估您的聽力健康狀況，僅需約 3 分鐘即可完成。
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-2xl mx-auto px-5 md:px-8 py-10 md:py-16">
        {step === 'intro' && (
          <div className="animate-fade-in-up">
            <div className="bg-white rounded-xl border border-[#E8E0D6] p-6 md:p-8">
              <h2 className="text-lg md:text-xl font-bold text-[#1B3D2A] mb-4">
                檢測說明
              </h2>
              <ul className="space-y-3 text-[#5A6B5A] text-sm md:text-base">
                <li className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#1B3D2A]/8 text-[#1B3D2A] text-xs font-bold shrink-0 mt-0.5">1</span>
                  <span>本檢測包含 12 道關於日常聽力情境的問題</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#1B3D2A]/8 text-[#1B3D2A] text-xs font-bold shrink-0 mt-0.5">2</span>
                  <span>請根據您過去 3 個月的真實感受作答</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#1B3D2A]/8 text-[#1B3D2A] text-xs font-bold shrink-0 mt-0.5">3</span>
                  <span>完成後將獲得聽力風險評估與建議</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#1B3D2A]/8 text-[#1B3D2A] text-xs font-bold shrink-0 mt-0.5">4</span>
                  <span>本檢測僅供參考，不能取代專業醫療診斷</span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-[#E8E0D6]">
                <div className="flex items-center gap-2 text-sm text-[#9A8A7A] mb-5">
                  <i className="ri-time-line"></i>
                  <span>預估時間：約 3 分鐘</span>
                </div>
                <button
                  type="button"
                  onClick={startQuiz}
                  className="w-full bg-[#1B3D2A] text-white px-6 py-3.5 rounded-xl text-base font-medium hover:bg-[#143026] transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <span>開始檢測</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 'quiz' && (
          <div className="animate-fade-in-up">
            <div className="mb-6 flex items-center justify-between text-sm text-[#9A8A7A]">
              <span>
                問題 {currentQ + 1} / {questions.length}
              </span>
              <span>{Math.round(((currentQ + 1) / questions.length) * 100)}%</span>
            </div>
            <ProgressBar current={currentQ} total={questions.length} />

            <div className="mt-8 bg-white rounded-xl border border-[#E8E0D6] p-6 md:p-8">
              <p className="text-lg md:text-xl font-semibold text-[#1B3D2A] leading-relaxed mb-6">
                {questions[currentQ].text}
              </p>
              <div className="space-y-3">
                {questions[currentQ].options.map((opt, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => selectOption(opt.value)}
                    className="w-full text-left px-5 py-3.5 rounded-lg border border-[#E8E0D6] bg-white text-[#1B3D2A] text-sm md:text-base hover:border-[#D4A574] hover:bg-[#F8F5F1] transition-all duration-200 flex items-center gap-3"
                  >
                    <span className="w-6 h-6 flex items-center justify-center rounded-full border border-[#E8E0D6] text-xs font-bold text-[#9A8A7A] shrink-0">
                      {String.fromCharCode(65 + idx)}
                    </span>
                    <span>{opt.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {step === 'result' && result && (
          <div className="animate-fade-in-up">
            <div className={`rounded-xl border ${result.border} ${result.bg} p-6 md:p-8 text-center mb-8`}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-white border border-[#E8E0D6]">
                <i className="ri-file-list-3-line text-2xl text-[#D4A574]"></i>
              </div>
              <p className="text-sm text-[#9A8A7A] mb-1">檢測結果</p>
              <h2 className={`text-2xl md:text-3xl font-bold ${result.color} mb-3`}>
                {result.level}
              </h2>
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="text-sm text-[#9A8A7A]">總分</span>
                <span className="text-3xl font-bold text-[#1B3D2A]">{totalScore}</span>
                <span className="text-sm text-[#9A8A7A]">/ {questions.length * 4} 分</span>
              </div>
              <p className="text-[#5A6B5A] text-sm md:text-base leading-relaxed max-w-md mx-auto">
                {result.desc}
              </p>
            </div>

            {/* Score visual */}
            <div className="bg-white rounded-xl border border-[#E8E0D6] p-6 md:p-8 mb-8">
              <h3 className="text-base font-bold text-[#1B3D2A] mb-4">分數分布</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-[#1B3D2A] shrink-0" />
                  <span className="text-sm text-[#5A6B5A] w-20">0-12 分</span>
                  <div className="flex-1 h-3 bg-[#E8E0D6] rounded-full overflow-hidden">
                    <div className="h-full bg-[#1B3D2A] rounded-full" style={{ width: '25%' }} />
                  </div>
                  <span className="text-xs text-[#9A8A7A] w-16 text-right">聽力正常</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-[#D4A574] shrink-0" />
                  <span className="text-sm text-[#5A6B5A] w-20">13-24 分</span>
                  <div className="flex-1 h-3 bg-[#E8E0D6] rounded-full overflow-hidden">
                    <div className="h-full bg-[#D4A574] rounded-full" style={{ width: '25%' }} />
                  </div>
                  <span className="text-xs text-[#9A8A7A] w-16 text-right">輕度風險</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-[#C75D3A] shrink-0" />
                  <span className="text-sm text-[#5A6B5A] w-20">25-36 分</span>
                  <div className="flex-1 h-3 bg-[#E8E0D6] rounded-full overflow-hidden">
                    <div className="h-full bg-[#C75D3A] rounded-full" style={{ width: '25%' }} />
                  </div>
                  <span className="text-xs text-[#9A8A7A] w-16 text-right">中度風險</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-[#A33D2A] shrink-0" />
                  <span className="text-sm text-[#5A6B5A] w-20">37-48 分</span>
                  <div className="flex-1 h-3 bg-[#E8E0D6] rounded-full overflow-hidden">
                    <div className="h-full bg-[#A33D2A] rounded-full" style={{ width: '25%' }} />
                  </div>
                  <span className="text-xs text-[#9A8A7A] w-16 text-right">重度風險</span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-[#E8E0D6]">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-[#D4A574] shrink-0" />
                  <span className="text-xs text-[#9A8A7A]">
                    您的分數位置（{totalScore} 分）
                  </span>
                </div>
                <div className="mt-2 h-3 bg-[#E8E0D6] rounded-full overflow-hidden relative">
                  <div className="h-full bg-[#1B3D2A] rounded-full" style={{ width: '100%' }} />
                  <div
                    className="absolute top-0 w-4 h-4 bg-[#D4A574] rounded-full border-2 border-white shadow-sm -translate-y-0.5"
                    style={{ left: `${(totalScore / 48) * 100}%`, transform: 'translateX(-50%) translateY(-2px)' }}
                  />
                </div>
              </div>
            </div>

            {/* Result explanation */}
            <div className="bg-white rounded-xl border border-[#E8E0D6] p-6 md:p-8 mb-8">
              <h3 className="text-base font-bold text-[#1B3D2A] mb-4">結果解說</h3>
              <div className="space-y-4 text-sm text-[#5A6B5A] leading-relaxed">
                <p>
                  本測驗採用標準化的聽力自我評估量表，透過 12 項日常情境評估您的聽力功能。總分範圍為 0–48 分，分數越高表示聽力困難的程度越明顯。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="flex items-start gap-2">
                    <div className="w-2 h-2 rounded-full bg-[#1B3D2A] mt-2 shrink-0" />
                    <span><strong className="text-[#1B3D2A]">0–12 分：</strong>聽力狀況良好，建議每年定期檢查</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-2 h-2 rounded-full bg-[#D4A574] mt-2 shrink-0" />
                    <span><strong className="text-[#1B3D2A]">13–24 分：</strong>可能存在輕度聽力困難，建議安排專業檢查</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-2 h-2 rounded-full bg-[#C75D3A] mt-2 shrink-0" />
                    <span><strong className="text-[#1B3D2A]">25–36 分：</strong>中度聽力風險，建議盡快評估助聽器需求</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-2 h-2 rounded-full bg-[#A33D2A] mt-2 shrink-0" />
                    <span><strong className="text-[#1B3D2A]">37–48 分：</strong>重度聽力風險，需立即尋求專業協助</span>
                  </div>
                </div>
                <p className="text-xs text-[#9A8A7A] pt-2 border-t border-[#E8E0D6]">
                  本測驗結果僅供參考，不能取代專業聽力檢查。如有疑慮，建議預約由國家認證聽力師進行的完整聽力評估。
                </p>
              </div>
            </div>

            {/* Chronic disease risk */}
            <div className="bg-[#FAF8F5] rounded-xl border border-[#E8E0D6] p-6 md:p-8 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#1B3D2A]/10 flex items-center justify-center shrink-0">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-heart-pulse-line text-xl text-[#1B3D2A]" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-[#1B3D2A]">慢性病風險評估</h3>
                  <p className="mt-2 text-sm text-[#5A6B5A] leading-relaxed">
                    聽力損失與糖尿病、高血壓、心血管疾病及認知退化密切相關。研究顯示，糖尿病者聽損風險增加 2.3 倍，重度聽損者失智風險增加 3.2 倍。
                    若您有慢性病或正在服用相關藥物，建議了解聽力與慢性病的關聯，並將聽力檢查納入慢性病管理計畫。
                  </p>
                  <div className="mt-4 flex flex-col sm:flex-row gap-3">
                    <button
                      type="button"
                      onClick={() => navigate('/hearing-chronic-disease')}
                      className="inline-flex items-center gap-2 bg-[#1B3D2A] text-white px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-[#143026] transition-colors"
                    >
                      <i className="ri-file-list-3-line" />
                      了解聽損與慢性病研究
                    </button>
                    <button
                      type="button"
                      onClick={() => navigate('/faq')}
                      className="inline-flex items-center gap-2 border border-[#E8E0D6] text-[#5A6B5A] px-5 py-2.5 rounded-xl text-sm font-medium hover:border-[#1B3D2A] hover:text-[#1B3D2A] transition-colors"
                    >
                      <i className="ri-questionnaire-line" />
                      查看常見問題
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => navigate('/booking')}
                className="flex-1 bg-[#1B3D2A] text-white px-6 py-3.5 rounded-xl text-base font-medium hover:bg-[#143026] transition-all duration-200 flex items-center justify-center gap-2"
              >
                <i className="ri-calendar-check-line"></i>
                <span className="whitespace-nowrap">{result.action}</span>
              </button>
              <button
                type="button"
                onClick={() => navigate('/products')}
                className="flex-1 border border-[#E8E0D6] text-[#5A6B5A] px-6 py-3.5 rounded-xl text-base font-medium hover:border-[#D4A574] hover:text-[#1B3D2A] transition-all duration-200 flex items-center justify-center gap-2"
              >
                <i className="ri-shopping-bag-3-line"></i>
                <span className="whitespace-nowrap">了解助聽器</span>
              </button>
              <button
                type="button"
                onClick={startQuiz}
                className="flex-1 border border-[#E8E0D6] text-[#5A6B5A] px-6 py-3.5 rounded-xl text-base font-medium hover:border-[#D4A574] hover:text-[#1B3D2A] transition-all duration-200 flex items-center justify-center gap-2"
              >
                <i className="ri-refresh-line"></i>
                <span className="whitespace-nowrap">重新檢測</span>
              </button>
            </div>

            <div className="mt-6 text-center">
              <p className="text-xs text-[#9A8A7A] leading-relaxed">
                本檢測結果僅供參考，無法取代專業醫療診斷。<br />
                如有聽力疑慮，建議盡快預約專業聽力檢查。
              </p>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}